import { render, staticRenderFns } from "./GettingStartedModal.vue?vue&type=template&id=ef9b3be4&scoped=true&"
import script from "./GettingStartedModal.vue?vue&type=script&lang=js&"
export * from "./GettingStartedModal.vue?vue&type=script&lang=js&"
import style0 from "./GettingStartedModal.vue?vue&type=style&index=0&id=ef9b3be4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9b3be4",
  null
  
)

export default component.exports